var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.step == "form"
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "form-group form__group",
              class: { "is-invalid": _vm.errors.name },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.contact.name,
                    expression: "contact.name",
                  },
                ],
                staticClass: "form-control form-control--white",
                attrs: { type: "text", placeholder: "Ваше имя" },
                domProps: { value: _vm.contact.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.contact, "name", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm.errors.name
                ? _c("p", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.errors.name.join(", ")) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group form__group",
              class: { "is-invalid": _vm.errors.phone },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.contact.phone,
                    expression: "contact.phone",
                  },
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "+7(###)###-##-##",
                    expression: "'+7(###)###-##-##'",
                  },
                ],
                staticClass: "form-control form-control--white",
                attrs: { type: "text", placeholder: "+7(xxx)xxx-xx-xx" },
                domProps: { value: _vm.contact.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.contact, "phone", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm.errors.phone
                ? _c("p", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n                " + _vm._s(_vm.errors.phone.join(", "))
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group form__group",
              class: { "is-invalid": _vm.errors.email },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.contact.email,
                    expression: "contact.email",
                  },
                ],
                staticClass: "form-control form-control--white",
                attrs: { type: "text", placeholder: "Email для ответа" },
                domProps: { value: _vm.contact.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.contact, "email", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm.errors.email
                ? _c("p", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n                " + _vm._s(_vm.errors.email.join(", "))
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group form__group",
              class: { "is-invalid": _vm.errors.client_type },
            },
            [
              _c("label", { staticClass: "form-label form__label" }, [
                _vm._v("Покупаете"),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contact.client_type,
                      expression: "contact.client_type",
                    },
                  ],
                  staticClass: "form-control form-control--white",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.contact,
                        "client_type",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c("option", { domProps: { value: "" } }, [
                    _vm._v("Выбрать"),
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: "personal" } }, [
                    _vm._v("Для себя"),
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: "company" } }, [
                    _vm._v("Для организации"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.errors.client_type
                ? _c("p", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.errors.client_type.join(", ")) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group form__group",
              class: { "is-invalid": _vm.errors.regular },
            },
            [
              _c("label", { staticClass: "form-label form__label" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contact.regular,
                      expression: "contact.regular",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.contact.regular)
                      ? _vm._i(_vm.contact.regular, null) > -1
                      : _vm.contact.regular,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.contact.regular,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.contact, "regular", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.contact,
                              "regular",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.contact, "regular", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" Периодические покупки\n            "),
              ]),
              _vm._v(" "),
              _vm.errors.regular
                ? _c("p", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.errors.regular.join(", ")) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-group form__group",
              class: { "is-invalid": _vm.errors.regular },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-group__checkboxes-group checkboxes-group",
                },
                [
                  _c(
                    "label",
                    {
                      staticClass:
                        "form-label form__label checkboxes-group__item",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.priceParts.Сейфы,
                            expression: "priceParts.Сейфы",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: "Сейфы",
                          checked: Array.isArray(_vm.priceParts.Сейфы)
                            ? _vm._i(_vm.priceParts.Сейфы, "Сейфы") > -1
                            : _vm.priceParts.Сейфы,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.priceParts.Сейфы,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "Сейфы",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.priceParts,
                                    "Сейфы",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.priceParts,
                                    "Сейфы",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.priceParts, "Сейфы", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" Сейфы\n                "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "form-label form__label checkboxes-group__item",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.priceParts.Шкафы,
                            expression: "priceParts.Шкафы",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: "Шкафы",
                          checked: Array.isArray(_vm.priceParts.Шкафы)
                            ? _vm._i(_vm.priceParts.Шкафы, "Шкафы") > -1
                            : _vm.priceParts.Шкафы,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.priceParts.Шкафы,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "Шкафы",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.priceParts,
                                    "Шкафы",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.priceParts,
                                    "Шкафы",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.priceParts, "Шкафы", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" Металлические шкафы и мебель\n                "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "form-label form__label checkboxes-group__item",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.priceParts.Стеллажи,
                            expression: "priceParts.Стеллажи",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: "Стеллажи",
                          checked: Array.isArray(_vm.priceParts.Стеллажи)
                            ? _vm._i(_vm.priceParts.Стеллажи, "Стеллажи") > -1
                            : _vm.priceParts.Стеллажи,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.priceParts.Стеллажи,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "Стеллажи",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.priceParts,
                                    "Стеллажи",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.priceParts,
                                    "Стеллажи",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.priceParts, "Стеллажи", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" Металлические Стеллажи\n                "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "form-label form__label checkboxes-group__item",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.priceParts["Гардеробные системы"],
                            expression: "priceParts['Гардеробные системы']",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: "Гардеробные системы",
                          checked: Array.isArray(
                            _vm.priceParts["Гардеробные системы"]
                          )
                            ? _vm._i(
                                _vm.priceParts["Гардеробные системы"],
                                "Гардеробные системы"
                              ) > -1
                            : _vm.priceParts["Гардеробные системы"],
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.priceParts["Гардеробные системы"],
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "Гардеробные системы",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.priceParts,
                                    "Гардеробные системы",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.priceParts,
                                    "Гардеробные системы",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.priceParts,
                                "Гардеробные системы",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._v(" Гардеробные системы\n                "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "form-label form__label checkboxes-group__item",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.priceParts["Медицинское оборудование"],
                            expression:
                              "priceParts['Медицинское оборудование']",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: "Медицинское оборудование",
                          checked: Array.isArray(
                            _vm.priceParts["Медицинское оборудование"]
                          )
                            ? _vm._i(
                                _vm.priceParts["Медицинское оборудование"],
                                "Медицинское оборудование"
                              ) > -1
                            : _vm.priceParts["Медицинское оборудование"],
                        },
                        on: {
                          change: function ($event) {
                            var $$a =
                                _vm.priceParts["Медицинское оборудование"],
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "Медицинское оборудование",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.priceParts,
                                    "Медицинское оборудование",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.priceParts,
                                    "Медицинское оборудование",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.priceParts,
                                "Медицинское оборудование",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._v(" Медицинское оборудование\n                "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "form-label form__label checkboxes-group__item",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.priceParts["Другое"],
                            expression: "priceParts['Другое']",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: "Другое",
                          checked: Array.isArray(_vm.priceParts["Другое"])
                            ? _vm._i(_vm.priceParts["Другое"], "Другое") > -1
                            : _vm.priceParts["Другое"],
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.priceParts["Другое"],
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "Другое",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.priceParts,
                                    "Другое",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.priceParts,
                                    "Другое",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.priceParts, "Другое", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" Другое\n                "),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.errors.regular
                ? _c("p", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.errors.regular.join(", ")) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__actions" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-primary accept-btn modal__accept-btn w-100",
                attrs: { type: "button" },
                on: { click: _vm.sendForm },
              },
              [_vm._v("Отправить")]
            ),
            _vm._v(" "),
            _vm._m(1),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.step == "complete"
      ? _c("div", [
          _c("p", { staticClass: "text-success" }, [
            _vm._v(
              "\n            Ваше сообщение успешно отправлено! Мы свяжемся с Вами в ближайшее время.\n        "
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "form-label form__label" }, [
      _c("strong", [_vm._v("Интересна продукция")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "form-accept__text text-center mt-2" }, [
      _vm._v("Отправляя вы принимаете "),
      _c("a", { attrs: { href: "/legal/" } }, [_vm._v("условия")]),
      _vm._v("\n                обработки персональных данных"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }